import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const ButtonPeer = ({ click, marged }) => {
  const useStyles = makeStyles((theme) => ({
    button: {
      textTransform: 'lowercase',
      fontWeight: 'bold',
      margin: marged ? '35px 0' : '',
      float: marged ? 'right' : 'unset'
    }
  }));

  const classes = useStyles();
  return (
    <Button
      className={classes.button}
      color="primary"
      onClick={click}
      variant="contained">
      see peer operating metrics
    </Button>
  );
};

export default ButtonPeer;
